
if(!customElements.get("section-toast")) {
  class SectionToast extends HTMLElement {
    constructor() {
      super();
      this.timeOut = null;

      this.addToCartMessage = this.getAttribute('data-add-to-cart-message');
      this.removeFromCartMessage = this.getAttribute('data-remove-from-cart-message');
      this.updateCartMessage = this.getAttribute('data-update-cart-message');

      this.removeButton = this.querySelector('[data-remove]');
      this.text = this.querySelector('[data-text]');
    }

    connectedCallback() {
      this.removeButton?.addEventListener('click', this.hide.bind(this));
      this.addEventListener('mouseenter', this.mouseEnter.bind(this));
      this.addEventListener('mouseleave', this.mouseLeave.bind(this));
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.hide);
      this.removeEventListener('mouseenter', this.mouseEnter);
      this.removeEventListener('mouseleave', this.mouseLeave);
    }

    mouseEnter() {
      clearTimeout(this.timeOut);
    }

    mouseLeave() {
      this.timeOut = setTimeout(() => this.hide(), 4000);
    }

    show(message) {
      this.text.innerHTML = message;
      this.classList.add('is-visible');

      this.timeOut = setTimeout(() => this.hide(), 4000);
    }

    hide() {
      this.classList.remove('is-visible');
      clearTimeout(this.timeOut);
    }

    addToCart() {
      this.show(this.addToCartMessage);
    }

    removeFromCart() {
      this.show(this.removeFromCartMessage);
    }

    updateCart() {
      this.show(this.updateCartMessage);
    }
  }

  customElements.define("section-toast", SectionToast);
}
